export const CURRENCY_RATIO = 1000;
export const currencyIsoCodes = Object.freeze({
    GBP: 'GBP'
});

export default class CurrencyHelper {
    static convertToPounds(price) {
        return typeof price === 'number' ? `£${(price / CURRENCY_RATIO).toFixed(2)}` : '£';
    }

    static getMinusPounds(origin, poundsCount) {
        return origin - poundsCount * CURRENCY_RATIO;
    }

    static getTotalMcFromTotal(total, masterCardDiscount = 0) {
        return Math.max(this.getMinusPounds(total, masterCardDiscount), 0);
    }
}
